import React from 'react';
import * as yup from 'yup';
import { SplitScreenPromo } from '@web/components';
import { CMSBlok } from '../CMSBlok';
import { linkSchema, nullableImageFromCMSSchema } from '../schemas';
import { schema as imageSchema } from './image';
import { schema as muxVideoSchema } from './mux_video';
import { schema as typewriterSchema } from './typewriter';

export const component = SplitScreenPromo;

export const schema = yup
  .object({
    contentBgColor: yup.string().nullable(),
    fontColor: yup.string().nullable(),
    imageBgColor: yup.string().nullable(),
    imageFirst: yup.boolean(),
    image: imageSchema.nullable(),
    backImage: imageSchema.nullable(),
    video: muxVideoSchema.nullable(),
    showVideo: yup.boolean().nullable(),
    link: linkSchema.nullable(),
    linkAlignment: yup.string().nullable(),
    content: yup.array(yup.object()),
    badges: yup.array(nullableImageFromCMSSchema),
    eyebrow: yup.string().nullable(),
    typewriterEyebrow: typewriterSchema.nullable(),
    showTypewriterAnimation: yup.boolean().nullable(),
  })
  .transform(value => ({
    contentBgColor: value.content_background_color,
    link: value.link?.[0] || null,
    linkAlignment: value?.link_alignment || undefined,
    fontColor: value.font_color || undefined,
    imageBgColor: value.image_background_color,
    image: value.image?.[0] || null,
    backImage: value?.back_image?.[0] || null,
    video: value?.video?.[0] || null,
    showVideo: value?.show_video ?? false,
    imageFirst: value.image_first_desktop,
    content:
      value.content?.map(innerContent => (
        <CMSBlok key={innerContent._uid} content={innerContent} />
      )) || [],
    eyebrow: value.eyebrow,
    typewriterEyebrow: value?.typewriter_eyebrow?.[0],
    showTypewriterAnimation: value?.show_typewriter_animation ?? false,
    badges: value?.badges,
  }));
